import styled from '@emotion/styled';
import { media } from '../../services/media';

export const Ups = styled.div`
    margin: 0 0 0.5em;
    line-height: 1;

    ${media.max('md')} {
        font-size: 42px;
    }

    ${media.between('md', 'xl')} {
        font-size: 80px;
    }

    ${media.min('xl')} {
        font-size: 160px;
    }
`;
